import { Flex } from 'components/Flex'
import { Role } from 'utils/constant'

import ContactSetting from './ContactSetting'
import NotificationSetting from './NotificationSetting'

export default function Setting({ account }) {
  return (
    <Flex>
      {!account.adminMode && <NotificationSetting account={account} />}
      {account.role !== Role.LOCATION_MEMBER.value && <ContactSetting account={account} />}
    </Flex>
  )
}
